var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-pagination',{attrs:{"length":_vm.length},on:{"input":function($event){return _vm.$emit('page-change', _vm.page)}},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})}
var staticRenderFns = []

export { render, staticRenderFns }